import request from '@/utils/http'

// 1 导师查询接口
export function tutorQueryList() {
    return request({
        url: '/api/portal/mentor/list',
        method: 'GET',
    })
}

// 2 门店服务轮播图接口
export function storeSwiperList() {
    return request({
        url: '/api/portal/banner/list?type=5',
        method: 'post',
    })
}
// 3 VR轮播图接口
export function vrSwipeList() {
    return request({
        url: '/api/portal/banner/list?type=4',
        method: 'post',
    })
}
// 4 视频教程
export function videoList() {
    return request({
        url: '/api/portal/video/list',
        method: 'GET',
    })
}

// 5 商圈板块
export function businessList() {
    return request({
        url: '/api/portal/districtarea/list',
        method: 'GET',
    })
}

// 6 主播列表数据
export function anchorList() {
    return request({
        url: '/api/portal/anchor/list',
        method: 'GET',
    })
}

// 7 3D城市地图
export function cityMapList() {
    return request({
        url: '/api/portal/citymap/list',
        method: 'GET',
    })
}

// 8 城市3D模型列表
export function modelBindMapList(params) {
    return request({
        url: `/api/portal/modelbindmap/buildingModelList?areaId=${params}`,
        method: 'GET',
    })
}

// 9 官网获客CRM
export function getCustomer(params) {
    return request({
        url: '/app/note/myNoteView/portalCustomer',
        method: 'POST',
        data: params,
    })
}

// 10 获取手机验证码
export function getSMSCode(phone) {
    return request({
        url: '/userservice/auth/sendMsg',
        method: 'get',
        params: { phone }, // 确保参数是一个对象
    })
}

// 11 获取城市列表
export function getCityList() {
    return request({
        url: '/vr/system/geo/cityTree',
        method: 'get',
    })
}

// 12 获取百亿像素
export function getBaiYiPixel() {
    return request({
        url: '/vr/home/VrBanner/list?type=2',
        method: 'get',
    })
}

// 13 获取城市精选内容
export function getCityContent() {
    return request({
        url: '/api/portal/vr/selected/list?pageNumber=1&pageSize=8',
        method: 'post',
        data: {
            pageNumber: 1,
            pageSize: 8,
        },
    })
}

// 14 获取新闻咨询
export function getNewsList(params) {
    return request({
        url: `/api/api/information/list?pageNum=1&pageSize=999`,
        method: 'post',
        data: params,
    })
}

// 15 获取咨询详情
export function getNewsDetail(id) {
    return request({
        url: `/api/api/information/getById?id=${id}`,
        method: 'get',
    })
}

// 16 获取vr标注信息
export function getVrInfo(workId, sceneId) {
    return request({
        url: `/vr/panowork/panowork/getSceneById?workId=${workId}&sceneId=${sceneId}`,
        method: 'get',
    })
}

// 17 获取官网活动信息
export function getActivityList() {
    return request({
        url: '/api/portal/banner/list?type=6',
        method: 'post',
    })
}
